import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Select, Switch } from "antd";
import { SingleImageUpload } from "components/SingleImageUpload";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import Swal from "sweetalert2";
import { getBase64Img } from "utils";

export const EditBannerModal: React.FC<any> = ({ ...props }) => {
	const [isActive, setIsActive] = useState<boolean>(false);
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);
	const [option, setOption] = useState<string>("");

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,

		currentImgURL,
		setProductStatus,

		setProductIsHighlight,
		currentBannerInfo,
		onUpdated
	} = props;
	const { Option } = Select;

	const handleRegister = (values: any) => {
		api
			.put(`/banners/${currentBannerInfo?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;

					onUpdated(result.data)

					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				title: currentBannerInfo?.title,
				description: currentBannerInfo?.description,
				url: currentBannerInfo?.url,
				position: currentBannerInfo?.position
					? currentBannerInfo?.position
					: "top",
				order: currentBannerInfo?.order ? currentBannerInfo?.order : 1,
			});
			setCurrentImgURL(
				currentBannerInfo?.image ? currentBannerInfo?.image : ""
			);
			setIsActive(currentBannerInfo?.is_active === true ? true : false);
		}
		// eslint-disable-next-line
	}, [isOpen]);

	const handleChangeImage = (imageUrl: string) => {
		setImageWasEdited(true)
		setCurrentImgURL(imageUrl)
	} 

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Editar banner</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar banner"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasEdited
							? {
									...values,
									is_active: isActive,
									image: currentImgURL,
									target: "_blank",
									type: "home",
							  }
							: {
									...values,
									target: "_blank",
									type: "home",
									is_active: isActive,
							  };

						handleRegister(allValues);
						setCurrentImgURL("");
						setProductStatus(false);
						setProductIsHighlight(false);
						setIsActive(false);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
				setProductStatus(false);
				setProductIsHighlight(false);
				setIsActive(false);
				form.resetFields();
			}}
			width={700}
		>
			<Form form={form} name="new-course" autoComplete="off" layout="vertical">
				<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={handleChangeImage}/>
				
				<div className="row mt-2">
					<Form.Item
						label="Título"
						name="title"
						rules={[
							{
								required: true,
								message: "Título necessário",
							},
						]}
					>
						<Input placeholder="Título do banner" />
					</Form.Item>
					<Form.Item
						label="Descrição"
						name="description"
						rules={[
							{
								required: true,
								message: "Descrição necessária",
							},
						]}
					>
						<Input placeholder="Descrição do banner" />
					</Form.Item>
					<Form.Item
						label="URL"
						name="url"
						rules={[
							{
								required: true,
								message: "URL necessária",
							},
						]}
					>
						<Input placeholder="URL do banner" />
					</Form.Item>

					<div className="row row-cols-md-3 pe-0">
						<Form.Item
							label="Ordem"
							name="order"
							rules={[
								{
									required: true,
									message: "Ordem necessária",
								},
							]}
							className="pe-0"
						>
							<Input type="number" placeholder="Ordem do banner" />
						</Form.Item>

						<Form.Item
							label="Posição"
							name="position"
							rules={[
								{
									required: true,
									message: "Visibilidade necessária",
								},
							]}
							className="pe-0"
						>
							<Select
								placeholder="Posição"
								className="m-product-modal__select"
								value={option}
								onChange={(e) => setOption(e)}
								style={{ width: "90%" }}
							>
								<Option value="top">Topo</Option>
								<Option value="footer">Rodapé</Option>
							</Select>
						</Form.Item>

						<div className="text-center">
							<p>Ativo</p>
							<Switch checked={isActive} onClick={(e) => setIsActive(e)} />
						</div>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
